import { Text } from '@chakra-ui/react'
import { useResponsive } from '@common/hooks'
import { IProductVariant } from '@common/interface/product'
import DeliveryDate from '@components/delivery-date'
import { useStore } from '@lib/context/store-context'
import { canBuy } from '@lib/util/can-buy'
import { LineItem, Region } from '@medusajs/medusa'
import LineItemOptions from '@modules/common/components/line-item-options'
import LineItemPrice from '@modules/common/components/line-item-price'
import NativeSelect from '@modules/common/components/native-select'
import Trash from '@modules/common/icons/trash'
import Thumbnail from '@modules/products/components/thumbnail'
import { useCart } from 'medusa-react'

type ItemProps = {
  item: Omit<LineItem, 'beforeInsert'>
  region: Region
}

const Item = ({ item, region }: ItemProps) => {
  const { updateItem, deleteItem } = useStore()
  const { cart } = useCart()

  const inStock = canBuy(item.variant)

  const image = (item.variant as IProductVariant).image || item.thumbnail

  const handleGetTitlePromotion = (id: string): string => {
    const tmpCart: any = cart
    if (tmpCart?.promotions) {
      const promotion = tmpCart?.promotions.find(
        (promotion: any) => promotion.id === id
      )
      return promotion ? promotion.description : ''
    }

    return ''
  }

  return (
    <div className="grid grid-cols-[122px_1fr] gap-4">
      <div className="w-full xs:w-[122px]">
        <Thumbnail thumbnail={image ?? item.thumbnail} size="full" />
      </div>
      <div className="flex flex-col text-base-regular gap-y-8">
        <div className="flex items-start justify-between">
          <div className="flex flex-col">
            <span>
              {item.title}{' '}
              {item.metadata?.promotion_id &&
                ` (Free item of promotion ${handleGetTitlePromotion(
                  item.metadata?.promotion_id as string
                )})`}
            </span>
            <LineItemOptions variant={item.variant} />
            <div
              style={{
                display: 'flex',
                gap: 5,
                alignItems: 'center',
                flexDirection: 'row'
              }}
            >
              <div className="text-gray-700 text-small-regular">
                Delivery date:
              </div>
              <DeliveryDate
                delivery_period={
                  (item as any)?.variant?.product?.delivery_period
                }
                textProps={{ fontSize: 'xs' }}
              />
            </div>
            {!inStock && (
              <Text
                style={{
                  color: 'red'
                }}
              >
                Out of stock
              </Text>
            )}
          </div>

          <NativeSelect
            value={item.quantity ?? 1}
            onChange={(value) => {
              updateItem({
                lineId: item.id,
                quantity: parseInt(value.target.value)
              })
            }}
            className="max-h-[35px] w-[75px]"
            disabled={
              !inStock ||
              !!item.metadata?.promotion_id ||
              !!item.metadata?.multi_commit_id
            }
          >
            {Array.from(
              [
                ...Array(
                  item.variant.inventory_quantity > 0
                    ? item.variant.inventory_quantity
                    : 10
                )
              ].keys()
            )
              .slice(0, 10)
              .map((i) => {
                const value = i + 1
                return (
                  <option value={value} key={i}>
                    {value}
                  </option>
                )
              })}
          </NativeSelect>
        </div>
        <div className="flex items-end justify-between flex-1 text-small-regular">
          <div>
            {!item.metadata?.promotion_id &&
              !item.metadata?.multi_commit_id && (
                <button
                  className="flex items-center text-gray-500 gap-x-1"
                  onClick={() => {
                    deleteItem(item.id)
                  }}
                >
                  <Trash size={14} />
                  <span>Remove</span>
                </button>
              )}
          </div>
          <div>
            <LineItemPrice item={item} region={region} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Item
